import clsx from "clsx";

// Shared styling for the checkout FormInputs — the control account form's
// email + password fields and the variant single-screen email field.
export const CHECKOUT_INPUT_CLASS =
  "h-[48px] border-none font-mabry-pro-regular !bg-ui-msg px-16px py-8px text-[#282828] placeholder:font-avenir-book placeholder:text-[#919191] placeholder:tracking-[0.04px] focus:!border focus:!border-solid focus:!border-black/20 focus:shadow-[0_0_10px_rgba(0,0,0,0.1)]";

export const InputErrorLabel = ({
  errorMessage,
}: {
  errorMessage?: string;
}) => {
  return (
    <p
      className={clsx(
        "px-16px sm:px-0 min-h-[24px] leading-[24px] font-mabry-pro-medium text-sm font-medium pt-0 text-error items-center mb-8px",
        errorMessage && "mt-[4px]",
      )}
    >
      {errorMessage}
    </p>
  );
};
